
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import { Typography, Paper, Button, List, ListItem, ListItemText, Grid } from '@material-ui/core';
import * as moment from 'moment';
import { IAppState, endpointStatusSubdivOperations, endpointOperationSubdivOperations } from '../../redux/modules';
import { CloseBackButton } from '../parts/CloseBackButton';
import { SiteInfoListSubdivState } from '../../redux/modules/siteInfoListSubdiv';
import { SiteInfo } from '../../models/SiteInfo';
import { KansatsuKirokuSubdivState, kansatsuKirokuSubdivOperations } from '../../redux/modules/kansatsuKirokuSubdiv';
import { NavLink } from 'react-router-dom';
import { EndpointStatusSubdivState } from '../../redux/modules/endpointStatusSubdiv';
import EndpointControl from '../parts/EndpointControl';
import { EndpointOperationSubdivState } from '../../redux/modules/endpointOperationSubdiv';
import { download } from '../../utils';

const styles = {
  contentBase: {
    padding: '10px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListSubdivState;
  clear: () => void;
  history: H.History;
  fetch: ({ koujiBangou }
      :{ koujiBangou: string }) => any;
  getEndpointStatusSubdiv: ({koujiBangou}: {koujiBangou: string}) => void;
  launchEndpoint: ({koujiBangou, operationKey}: {koujiBangou: string; operationKey: string}) => void;
  stopEndpoint: ({koujiBangou, operationKey}: {koujiBangou: string; operationKey: string}) => void;
  kansatsuKirokuSubdiv: KansatsuKirokuSubdivState;
  endpointStatusSubdiv: EndpointStatusSubdivState;
  endpointOperationSubdiv: EndpointOperationSubdivState;
}

interface OwnState {
  // 工事現場の情報
  site: SiteInfo | undefined;
};

class KansatuKirokuSubdivListPage extends React.Component<OwnProps, OwnState>{
  // endpoint状態を定期的に取得するタイマー
  private endpointStatusSubdivTimerId;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: undefined
    };
  }
  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/subdiv/sitelist');
      return ;
    }
    this.setState({ site: siteInfo });

    // 検索
    this.props.fetch({ koujiBangou });

    // SageMaker Endpointの起動状態を取得する
    this.props.getEndpointStatusSubdiv({ koujiBangou });
    // 状態取得タイマー設定
    this.endpointStatusSubdivTimerId = setInterval(() => {
      // SageMaker Endpointの起動状態を取得する
      this.props.getEndpointStatusSubdiv({ koujiBangou });
    }, 10000);
  }
  componentWillUnmount() {
    if (this.endpointStatusSubdivTimerId) {
      clearInterval(this.endpointStatusSubdivTimerId);
      this.endpointStatusSubdivTimerId = '';
    }
  }
  launchEndpoint(operationKey:string) {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    this.props.launchEndpoint({ koujiBangou, operationKey });
  }
  stopEndpoint(operationKey:string) {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    this.props.stopEndpoint({ koujiBangou, operationKey });
  }

  render() {
    const site = this.state.site || new SiteInfo();
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <Paper
          style={styles.contentBase}
        >
          <Button
            disabled={this.props.endpointStatusSubdiv.status !== 'InService'}
            variant="contained"
            color="secondary"
            fullWidth
            // 新規作成のときはtimestampの部分に__NEW__を設定して識別する
            onClick={() =>
              this.props.history.push(`/subdiv/kansatsukiroku/${this.props.match.params.koujibangou}/__NEW__`)}
          >
            診断する
          </Button>
          <EndpointControl
            status={this.props.endpointStatusSubdiv.status}
            hasError={!this.props.endpointOperationSubdiv.success}
            message={this.props.endpointOperationSubdiv.message}
            onLaunch={(operationKey: string) => {
              this.launchEndpoint(operationKey);
            }}
            onStop={(operationKey: string) => {
              this.stopEndpoint(operationKey);
            }}
          />
        </Paper>
        <Paper
          style={styles.contentBase}
        >
          <Typography variant="h6">
            [細分化画像]-観察記録
          </Typography>
          <hr/>
          <List>
              {this.props.kansatsuKirokuSubdiv.items.map((item, index) => {
                return (
                  <ListItem
                    button
                    divider
                    key={item.key}
                  >
                    <Grid container alignItems="center">
                      <Grid item sm={7} xs={12}>
                        <NavLink
                          key={`link_${index}`}
                          style={{textDecoration: 'none', color: 'unset'}}
                          to={`/subdiv/kansatsukiroku/${item.koujiBangou}/${item.key}`}
                        >
                          <ListItemText
                            primary={`観察年月日 : ${item.kansatsuDate ? moment(item.kansatsuDate, 'YYYY-MM-DD').format('YYYY年MM月DD日') : '無し'}`}
                            secondary={`測点No : ${item.sokutenNumber || '無し'} / 断面番号 : ${item.danmenNumber || '無し'} / 坑口からの距離 : ${item.kyori || '無し'}`}
                          />
                        </NavLink>
                      </Grid>
                      <Grid item sm={2} xs={12}>
                        <Typography variant="caption" style={{ color: 'rgba(0,0,0,0.54)', width: '110px'}}>
                          作成：
                          {(item.createdAt) ? moment(item.createdAt).format('MM/DD HH:mm') : '-'} <br/>
                          更新：
                          {(item.lastModifiedAt) ? moment(item.lastModifiedAt).format('MM/DD HH:mm') : '-'}
                        </Typography>
                      </Grid>
                      <Grid item sm={3} xs={12}>
                        <div>
                          <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            style={{ margin: '5px' }}
                            disabled={item.downloadFileStatus !== 'created'}
                            onClick={() => {
                              download(item.downloadFileBucket, item.downloadFileKey);
                            }}
                          >
                            ダウンロード
                          </Button>
                        </div>
                        <div>
                          {
                            (item.downloadFileCreationDatetime)
                             ? (
                              <Typography variant="caption" style={{ color: 'rgba(0,0,0,0.54)'}}>
                                {moment(item.downloadFileCreationDatetime).format('MM/DD HH:mm')}に作成
                              </Typography>
                             )
                             : (null)
                          }
                        </div>
                      </Grid>                    </Grid>
                  </ListItem>
              );
              })}
          </List>
          {
            this.props.kansatsuKirokuSubdiv.items.length === 0
              ? (<Typography variant="body2">データはありません</Typography>)
              : (<div style={{ width: '100%', textAlign: 'right' }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.props.history.push(`/fullarchivedownloadsubdiv/${site.koujiBangou}`);
                  }}
                >
                  一括ダウンロードページへ
                </Button>
              </div>)
          }
        </Paper>
        <CloseBackButton history={this.props.history} />
      </Paper>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    fetch: ({ koujiBangou }) => {
      kansatsuKirokuSubdivOperations.fetch({ koujiBangou })(dispatch);
    },
    getEndpointStatusSubdiv: ({ koujiBangou }) => {
      endpointStatusSubdivOperations.get({ koujiBangou })(dispatch);
    },
    launchEndpoint: (param) => {
      endpointOperationSubdivOperations.launchEndpointSubdiv(param)(dispatch);
    },
    stopEndpoint: (param) => {
      endpointOperationSubdivOperations.stopEndpointSubdiv(param)(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoListSubdiv,
    endpointStatusSubdiv: appState.endpointStatusSubdiv,
    endpointOperationSubdiv: appState.endpointOperationSubdiv,
    kansatsuKirokuSubdiv: appState.kansatsuKirokuSubdiv
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KansatuKirokuSubdivListPage);



// WEBPACK FOOTER //
// ./src/components/subdiv/KansatuKirokuSubdivListPage.tsx